import React, { useEffect } from 'react';
import { useState, Downgraded } from '@hookstate/core';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Divider,
    TextField,
    InputAdornment,
    Chip,
    Select,
    MenuItem,
    Tooltip,
    IconButton,
    Button,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import ButtonContainer from '../../../sharedcomponents/buttoncontainer/buttonContainer';
import StyledTableCell from '../../../sharedcomponents/styledTable/styledTableCell';
import StyledTableRow from '../../../sharedcomponents/styledTable/styledTableRow';
import UserMediaCircuit from './userMediaCircuit';
import ApiHelper from '../../../utility/ApiHelper';
import APIURLConstants from '../../../config/config';
import Helper from '../../../utility/helper';
import ExportExcelIcon from '../../../sharedcomponents/customIcons/exportExcelIcon';
import ConfirmationDialog from '../../../sharedcomponents/confirmationdialog/confirmationDialog';
import { makeStyles } from '@mui/styles';
import StatusCount from '../../MediaCircuit/statusCount';
import UserCount from '../../MediaCircuit/userCount';

const useStyles = makeStyles(() => ({

    stickyColumn: {
        position: 'sticky', left: 0, zIndex: 800, backgroundColor: 'white'
    },
    stickyHeaderColumn: {
        position: 'sticky',
        left: 0,
        zIndex: 900
    },
}));

const UserMediaCircuitList = (props) => {
    const classes = useStyles();
    const columnsData = useState(null);
    const rowsData = useState(null);
    const disableButton = useState(false);
    const [search, setSearch] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    // const [postData, setPostData] = React.useState([]);
    const [dialogData, setDialogData] = React.useState();

    const confirmDialog = useState({
        open: false,
        title: '',
        message: '',
        access: null
    });
    const filterRowsData = useState(null);
    useEffect(() => {
        // if (props.data && columnsData.get() == null && rowsData.get() == null) {
            const { columns, rows } = props.data;
            if (columns.length > 0 && rows.length > 0) {
                let newRows = setRowAllModulePermission(rows);
                rowsData.set(JSON.parse(JSON.stringify(newRows)));
                filterRowsData.set(JSON.parse(JSON.stringify(newRows)));
                let newColumns = setAllHeaderPermission(columns, newRows);
                columnsData.set(JSON.parse(JSON.stringify(newColumns)));
                search.length > 0 ? handleSearchChange(search) : null;
            }
        // }
    }, [props]);

    const handleSearchChange = (data) => {
        const value = data.trimStart();
        setSearch(value);
        if (value.length === 0) {
            resetCompletedCount(rowsData.attach(Downgraded).get());
            return;
        }
        const newFilterRowsData = [...rowsData.attach(Downgraded).get()];
        const lowerValue = value.toLowerCase();
        const modifyList = [];
        for (const row of newFilterRowsData) {
            for (const key of ['userName', 'role', 'tags', 'contentCircuitDateTime']) {
                const item = row[key];
                if (item && typeof item.label === 'string' && item.label.toLowerCase().includes(lowerValue)) {
                    modifyList.push(row);
                    break;
                }
            }
        }
        filterRowsData.set(modifyList);
        resetCompletedCount(modifyList)
    };
    const resetCompletedCount = (modifiedList) => {
        const { columns, rows } = props.data;
        if (columns && columns.length > 0 && rows && rows.length > 0) {
            let newRows = setRowAllModulePermission(modifiedList);
            filterRowsData.set(JSON.parse(JSON.stringify(newRows)));
            let newColumns = setAllHeaderPermission(columns, newRows);
            columnsData.set(JSON.parse(JSON.stringify(newColumns)));
        }
    }
    // console.log(filterRowsData.attach(Downgraded).get());

    const handleClick = async () => {
        let userPermission = [];
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        // e.preventDefault();
        if (filterRowsData.get() && filterRowsData.get().length > 0) {
            let newFilterRowsData = [...filterRowsData.attach(Downgraded).get()];
            let oldRowsData = [...rowsData.attach(Downgraded).get()];

            var newRowsData = newFilterRowsData.filter(function (p, idx) {
                return JSON.stringify(p) !== JSON.stringify(oldRowsData[idx]);
            });

            if (newRowsData && newRowsData.length > 0) {
                newRowsData.map((row) => {
                    let keys = Object.keys(row);
                    let obj = {};
                    let userName = row.userName;
                    let oldRecord;
                    if (userName && userName.userID) {
                        obj['userID'] = userName.userID;
                        oldRecord = oldRowsData.find(i => i.userName && i.userName.userID === userName.userID);
                    }
                    keys.forEach((key) => {
                        if (
                            key != 'allModules' &&
                            key != 'role' &&
                            key != 'userName' &&
                            key != 'tags'
                        ) {
                            if (row[key]['status'] &&
                                (!oldRecord || (oldRecord && JSON.stringify(oldRecord[key]) !== JSON.stringify(row[key])))) {
                                obj['eventID'] = eventInfo.eventID;
                                obj['activityTrackerID'] = row[key]['activityTrackerID'];
                                obj['completed'] =
                                    row[key].permission == null
                                        ? 0
                                        : row[key].permission;
                                obj['createdBy'] = userInfo.userID;
                                userPermission.push(obj);
                                obj = {
                                    ...obj,
                                    eventID: 0,
                                    moduleID: 0,
                                    completed: 0,
                                    createdBy: 0,
                                };
                            }
                        }
                    });
                });
            }
        }

        if (userPermission && userPermission.length > 0) {
            disableButton.set(true);
            await ApiHelper.post(
                APIURLConstants.POST_USER_ACTIVITY_TRACKER_MARK_ACTIVITIES,
                userPermission
            )
                .then((res) => {
                    if (res.data) {
                        sendCombineTrackerEmail(res.data);
                        // rowsData.set(null);
                        // columnsData.set(null);
                        // filterRowsData.set(null);
                        props.setActivityID(userPermission[0].activityTrackerID);
                        props.getAllData();
                        disableButton.set(false);
                    }
                })
                .catch((err) => {
                    if (err) {
                        console.log('err : ', err);
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Error in Media Circuit updates',
                        });
                        disableButton.set(false);
                    }
                });
        }
    };
    const sendCombineTrackerEmail = (result) => {
        const eventInfo = Helper.getStorage('eventInfo');
        let obj = {};
        obj.ID = 0;
        obj.IDs = result.toString();
        obj.eventID = eventInfo.eventID;
        obj.templateType = "Mark";
        obj.ModuleID = 24;

        ApiHelper.post(
            APIURLConstants.SEND_ACTIVITY_TRACKER_EMAIL,
            obj)
            .then((res) => {

            })
            .catch((err) => {
                if (err) {
                    console.log('err while sending combine activity tracker email : ', err);
                }
            });
    }

    const handleCancel = () => {
        const { columns, rows } = props.data;
        if (columns.length > 0 && rows.length > 0) {
            columnsData.set(JSON.parse(JSON.stringify(columns)));
            rowsData.set(JSON.parse(JSON.stringify(rows)));
            filterRowsData.set(JSON.parse(JSON.stringify(rows)));
        }
    };
    const setAllHeaderPermission = (columns, rows) => {
        columns.map((column) => {
            if (
                column.id != 'userName' &&
                column.id != 'role' &&
                column.id != 'tags'
            ) {
                let totalRows = 0;
                let perm0 = 0;
                let perm1 = 0;
                let perm2 = 0;
                rows.forEach((row) => {
                    let keys = Object.keys(row);
                    keys.forEach((key) => {
                        if (key == column.id) {
                            if (row[key]['permission'] == 0) perm0++;
                            else if (row[key]['permission'] == 1) perm1++;
                            else if (row[key]['permission'] == 2) perm2++;

                            //added this check if activity is not assigned then don't count that activity
                            if (row[key]['status'])
                                totalRows++;
                        }
                    });
                });
                column.inCompletedCount = totalRows - perm1;
                column.completedCount = perm1;
                if (totalRows > 0 && totalRows == perm0) {
                    column.permission = 0;
                } else if (totalRows > 0 && totalRows == perm1) {
                    column.permission = 1;
                } else if (totalRows > 0 && totalRows == perm2) {
                    column.permission = 2;
                } else {
                    column.permission = null;
                }
            }
        });
        return columns;
    };

    const setColumnHeaderPermission = (column, colIndex) => {
        column.permission = null;
        let newRowsData = [...filterRowsData.attach(Downgraded).get()];

        let totalRows = 0;
        let perm0 = 0;
        let perm1 = 0;
        let perm2 = 0;
        newRowsData.map((row) => {
            let keys = Object.keys(row);
            keys.map((key) => {
                if (key == column.id) {
                    if (row[key]['permission'] == 0) perm0++;
                    else if (row[key]['permission'] == 1) perm1++;
                    else if (row[key]['permission'] == 2) perm2++;

                    //added this check if activity is not assigned then don't count that activity
                    if (row[key]['status'])
                        totalRows++;
                }
            });
        });
        if (totalRows > 0 && totalRows == perm0) {
            column.permission = 0;
        } else if (totalRows > 0 && totalRows == perm1) {
            column.permission = 1;
        }
        if (totalRows > 0 && totalRows == perm2) {
            column.permission = 2;
        }
        let newColumnsData = [...columnsData.attach(Downgraded).get()];
        if (column.permission == null) {
            const fIndex = newColumnsData.findIndex(
                (col) => col.id == 'allModules'
            );

            newColumnsData[fIndex].permission = null;
            const newColumn = { ...newColumnsData[fIndex] };
            columnsData[fIndex].set(newColumn);
        }
        columnsData[colIndex].set(column);
        setTimeout(() => {
            let newRowsData = [...filterRowsData.attach(Downgraded).get()];
            let newColumnsData = [...columnsData.attach(Downgraded).get()];
            let newColumns = setAllHeaderPermission(
                newColumnsData,
                newRowsData
            );
            columnsData.set(newColumns);
        }, 100);
    };

    const setUserPermission = async (rowIndex, colIndex, column, access) => {
        setLoading(false);
        // console.log('trace 1');
        let newRowsData = [...filterRowsData.attach(Downgraded).get()];
        // console.log('rowIndex', rowIndex);
        // console.log('colIndex', colIndex);
        // console.log('column', column);
        let permission = access;

        let row = newRowsData[rowIndex];
        // console.log("row",row);
        //let postNewData = []

        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        if (column.id == 'allModules') {
            if (row['allModules']['permission'] === 1) {
                permission = 0;
            } else {
                permission = 1;
            }
            let keys = Object.keys(row);
            keys.map((key) => {
                if (key != 'userName' && key != 'role' && key != 'tags') {
                    // console.log(row[key]['permission']);
                    row[key]['permission'] = permission;
                }
            });
            filterRowsData[rowIndex].set(row);
            setColumnHeaderPermission(column, colIndex);
        } else if (
            column.id != 'userName' &&
            column.id != 'role' &&
            column.id != 'tags'
        ) {
            // console.log(row[column.id]['permission']);
            row[column.id]['permission'] =
                row[column.id]['permission'] === 1 ? 0 : 1;
            row['allModules']['permission'] = null;

            // logic to set all modules permission if all other modules are set to same permission for user
            let keys = Object.keys(row);
            let perm0 = 0;
            let perm1 = 0;
            let perm2 = 0;
            let moduleCount = 0;
            keys.map((key) => {
                if (
                    key != 'userName' &&
                    key != 'role' &&
                    key != 'allModules' &&
                    key != 'tags'
                ) {
                    if (row[key]['permission'] == 0) perm0++;
                    else if (row[key]['permission'] == 1) perm1++;
                    else if (row[key]['permission'] == 2) perm2++;
                    moduleCount++;
                }
            });
            if (moduleCount > 0 && moduleCount == perm0) {
                row['allModules']['permission'] = 0;
            } else if (moduleCount > 0 && moduleCount == perm1) {
                row['allModules']['permission'] = 1;
            } else if (moduleCount > 0 && moduleCount == perm2) {
                row['allModules']['permission'] = 2;
            }
            // postNewData.push({
            //     userID: row.userName.userID,
            //     activityTrackerID: column.activityTrackerID,
            //     completed: permission == null ? 0 : permission,
            //     createdBy: userInfo.userID,
            //     eventID: eventInfo.eventID
            // });

            filterRowsData[rowIndex].set(JSON.parse(JSON.stringify(row)));
            // set column header permission as per all rows permission in the same column
            setColumnHeaderPermission(column, colIndex);
        }
        handleClick();
        setLoading(true);
    };

    // const delay = (t) => new Promise((resolve) => setTimeout(resolve, t));

    const setHeaderPermission = (newColumnsData) => {
        let perm0 = 0;
        let perm1 = 0;
        let perm2 = 0;
        let moduleCount = 0;
        let fIndex = newColumnsData.findIndex((col) => col.id == 'allModules');
        newColumnsData.map((col) => {
            if (
                col.id != 'userName' &&
                col.id != 'role' &&
                col.id != 'allModules' &&
                col.id != 'tags'
            ) {
                if (col['permission'] == 0) perm0++;
                else if (col['permission'] == 1) perm1++;
                else if (col['permission'] == 2) perm2++;
                moduleCount++;
            }
        });
        if (fIndex > -1) {
            if (moduleCount > 0 && moduleCount == perm0) {
                newColumnsData[fIndex].permission = 0;
            } else if (moduleCount > 0 && moduleCount == perm1) {
                newColumnsData[fIndex].permission = 1;
            }
            if (moduleCount > 0 && moduleCount == perm2) {
                newColumnsData[fIndex].permission = 2;
            }
        }
        return newColumnsData;
    };

    const setRowAllModulePermission = (newRowsData) => {
        newRowsData.map((row) => {
            row['allModules']['permission'] = null;
            let perm0 = 0;
            let perm1 = 0;
            let perm2 = 0;
            let moduleCount = 0;
            let keys = Object.keys(row);
            keys.map((key) => {
                if (
                    key != 'userName' &&
                    key != 'role' &&
                    key != 'allModules' &&
                    key != 'tags'
                ) {
                    if (row[key]['permission'] == 0) perm0++;
                    else if (row[key]['permission'] == 1) perm1++;
                    else if (row[key]['permission'] == 2) perm2++;
                    moduleCount++;
                }
            });
            if (moduleCount > 0 && moduleCount == perm0) {
                row['allModules']['permission'] = 0;
            } else if (moduleCount > 0 && moduleCount == perm1) {
                row['allModules']['permission'] = 1;
            } else if (moduleCount > 0 && moduleCount == perm2) {
                row['allModules']['permission'] = 2;
            }
        });
        return newRowsData;
    };

    const setUserHeadPermission = (colIndex, column, access) => {
        showConfirmationDialog(column ? column.label : '', access);
        let newRowsData = [...filterRowsData.attach(Downgraded).get()];
        let newColumnsData = [...columnsData.attach(Downgraded).get()];
        let permission = access;
        // var filterData = postData.filter(x => {
        //     return x.activityTrackerID != column.activityTrackerID;
        // })
        //setPostData(filterData)
        if (column && column.id == 'allModules') {
            newColumnsData.map((colData) => {
                if (
                    colData.id != 'userName' &&
                    colData.id != 'role' &&
                    colData.id != 'tags'
                ) {
                    colData.permission = permission;
                }
            });
            newRowsData.map((row) => {
                let keys = Object.keys(row);
                keys.map((key) => {
                    if (key != 'userName' && key != 'role' && key != 'tags') {
                        row[key].permission = permission;
                    }
                });
            });
        } else {
            const eventInfo = Helper.getStorage('eventInfo');
            const userInfo = Helper.getStorage('userInfo');
            newColumnsData[colIndex].permission = permission;
            newRowsData.map((row) => {
                let keys = Object.keys(row);
                keys.map((key) => {
                    if (key == column.id) {
                        row[key].permission = permission;
                        // if (row[key].status != null) {
                        //     setPostData(oldArray => [...oldArray,
                        //     {
                        //         userID: row.userName.userID,
                        //         activityTrackerID: row[key].activityTrackerID,
                        //         completed: row[key].permission == null ? 0 : row[key].permission,
                        //         createdBy: userInfo.userID,
                        //         eventID: eventInfo.eventID
                        //     }]);
                        // }
                    }
                });
            });

            let fIndex = newColumnsData.findIndex(
                (col) => col.id == 'allModules'
            );
            if (fIndex > -1) {
                newColumnsData[fIndex].permission = null;
            }
            // column.permission = permission;
            // columnsData[colIndex].set(column);

            // check all modules permission
            newColumnsData = setHeaderPermission(newColumnsData);
            newRowsData = setRowAllModulePermission(newRowsData);
        }
        columnsData.set(newColumnsData);
        //rowsData.set(newRowsData);
        filterRowsData.set(newRowsData);
    };
    const showConfirmationDialog = (message, access) => {
        setDialogData(message)
        confirmDialog.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            access: access
        });
    }
    const handleSubmit = () => {
        handleClick()
        confirmDialog.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            access: null
        });
    }
    const handleRefreshClick = () => {
        props.getAllData();
    }

    const onConfirmationCancel = () => {
        setDialogData('');
        confirmDialog.set({
            ...confirmDialog.get(),
            open: false,
            access: null
        });
        handleCancel();
    }

    const messageFormat = () => {
        return (
            <>  <span>Are you sure you want to {confirmDialog.get().access ? 'mark' : 'unmark'} </span> <span style={{ fontWeight: 'bold' }}> {dialogData}</span> {' activity for all users?'} </>
        )
    }
    const handleClearSearchChange = () => {
        setSearch('')
        resetCompletedCount(rowsData.attach(Downgraded).get())
    }
    return (
        // <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <>
            {columnsData.get() && filterRowsData.get() && loading ? (
                <>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                minHeight: '56px',
                                mb: 1.5,
                            }}>
                            <TextField
                                id="search"
                                size="small"
                                label={'Search'}
                                value={search}
                                onChange={(event) => { handleSearchChange(event.target.value)}}
                                autoComplete="off"
                                InputProps={{
                                    endAdornment: (
                                        <>
                                            <InputAdornment position="end">
                                                <SearchIcon />
                                            </InputAdornment>
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={
                                                        handleClearSearchChange
                                                    }>
                                                    <CloseOutlinedIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        </> 
                                    ),
                                }}
                                sx={{
                                    mr: 2,
                                    maxWidth: { xs: '180px', md: '90%' },
                                }}
                            />
                            <Select
                                size="small"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={props.selectedActivityID}
                                label="Activities"
                                onChange={(event) =>
                                    props.onChangeMediaCircuitActivities(event)
                                }>
                                <MenuItem selected value={0}>
                                    All
                                </MenuItem>
                                {props.activitiesData &&
                                    props.activitiesData.length > 0 &&
                                    props.activitiesData.map((option) => {
                                        return (
                                            <MenuItem
                                                key={option.activityTrackerID}
                                                value={option.activityTrackerID}
                                                sx={{
                                                    backgroundColor:
                                                        option.activityTrackerID ===
                                                            props.selectedActivityID
                                                            ? '#ccc'
                                                            : '',
                                                }}>
                                                {option.name}
                                            </MenuItem>
                                        );
                                    })}
                            </Select>

                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                mb: 1.5,
                                alignItems: 'center'
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                }}
                                component="span">
                                <Tooltip title={'Export Report'}>
                                    <IconButton
                                        color="primary"
                                        onClick={props.generateExcelReport}>
                                        <ExportExcelIcon
                                            fontSize="small"
                                            style={{ color: '#008000' }}
                                        />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Button
                                type="submit"
                                variant="contained"
                                onClick={handleRefreshClick}
                                disabled={
                                    disableButton.get() != undefined
                                        ? disableButton.get()
                                        : false
                                }
                                sx={{
                                    width: '100px',
                                    marginTop: "-2px",
                                    justifyContent: 'center',
                                }}>
                                Refresh
                            </Button>
                        </Box>
                    </Box>

                    <Box
                        // component="form"
                        sx={{
                            // p: 2,
                            width: '100%', overflow: 'hidden'
                        }}
                        autoComplete="off"
                    // onSubmit={handleClick}
                    >
                        <TableContainer component={Paper} sx={{ maxHeight: '70vh' }}>
                            <Table stickyHeader >
                                <TableHead>
                                    <TableRow size="small">
                                        {columnsData
                                            .attach(Downgraded)
                                            .get()
                                            .map((column, index) => {
                                                if (
                                                    column.id !== 'allModules'
                                                ) {
                                                    if (
                                                        props.selectedActivityID ===
                                                        0
                                                    ) {
                                                        if (
                                                            column.id !==
                                                            'completedOn'
                                                        ) {
                                                            return (
                                                                <StyledTableCell
                                                                    key={`column_${index}`}
                                                                    align={
                                                                        column.align
                                                                    }
                                                                    size="small"
                                                                    className={column.id === 'userName' ? classes.stickyHeaderColumn : ''}>
                                                                    <Box
                                                                        display="flex"
                                                                        flexDirection={
                                                                            'column'
                                                                        }
                                                                        alignItems={
                                                                            column.align ==
                                                                                'left'
                                                                                ? 'flex-start'
                                                                                : 'center'
                                                                        }>
                                                                        <Typography
                                                                            variant="h4"
                                                                            flexGrow={
                                                                                1
                                                                            }
                                                                            fontSize={
                                                                                12
                                                                            }
                                                                            fontWeight={
                                                                                500
                                                                            }
                                                                            color="primary">
                                                                            {column.id === 'userName' ? (
                                                                                <>
                                                                                    {column.label} &nbsp;
                                                                                    <UserCount filterRowsData={filterRowsData.get()} />
                                                                                </>) : (
                                                                                column.label
                                                                            )}
                                                                        </Typography>
                                                                        {column.showPermission ? (
                                                                            <>
                                                                                <StatusCount
                                                                                    index={index}
                                                                                    column={column}
                                                                                />
                                                                                <UserMediaCircuit
                                                                                    header={
                                                                                        true
                                                                                    }
                                                                                    column={
                                                                                        column
                                                                                    }
                                                                                    colIndex={
                                                                                        index
                                                                                    }
                                                                                    setUserHeadPermission={
                                                                                        setUserHeadPermission
                                                                                    }
                                                                                />
                                                                            </>
                                                                        ) : null}
                                                                    </Box>
                                                                </StyledTableCell>
                                                            );
                                                        }
                                                    } else {
                                                        return (
                                                            <StyledTableCell
                                                                key={`column_${index}`}
                                                                align={
                                                                    column.align
                                                                }
                                                                size="small"
                                                                className={column.id === 'userName' ? classes.stickyHeaderColumn : ''}>
                                                                <Box
                                                                    display="flex"
                                                                    flexDirection={
                                                                        'column'
                                                                    }
                                                                    alignItems={
                                                                        column.align ==
                                                                            'left'
                                                                            ? 'flex-start'
                                                                            : 'center'
                                                                    }>
                                                                    <Typography
                                                                        variant="h4"
                                                                        flexGrow={
                                                                            1
                                                                        }
                                                                        fontSize={
                                                                            12
                                                                        }
                                                                        fontWeight={
                                                                            500
                                                                        }
                                                                        color="primary">
                                                                        {
                                                                            column.label
                                                                        }
                                                                    </Typography>
                                                                    {column.showPermission ? (
                                                                        <UserMediaCircuit
                                                                            header={
                                                                                true
                                                                            }
                                                                            column={
                                                                                column
                                                                            }
                                                                            colIndex={
                                                                                index
                                                                            }
                                                                            setUserHeadPermission={
                                                                                setUserHeadPermission
                                                                            }
                                                                        />
                                                                    ) : null}
                                                                </Box>
                                                            </StyledTableCell>
                                                        );
                                                    }
                                                }
                                            })}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filterRowsData.get()
                                        ? filterRowsData
                                            .attach(Downgraded)
                                            .get()
                                            .map((row, rowIndex) => {
                                                // console.log(row, rowIndex);
                                                return (
                                                    <StyledTableRow
                                                        key={`row_${rowIndex}`}
                                                        hover
                                                        tabIndex={-1}>
                                                        {columnsData
                                                            .attach(
                                                                Downgraded
                                                            )
                                                            .get()
                                                            .map(
                                                                (
                                                                    column,
                                                                    colIndex
                                                                ) => {
                                                                    const value =
                                                                        row[
                                                                        column
                                                                            .id
                                                                        ];

                                                                    if (
                                                                        props.selectedActivityID ===
                                                                        0
                                                                    ) {
                                                                        if (
                                                                            column.id !==
                                                                            'allModules' &&
                                                                            column.id !==
                                                                            'completedOn'
                                                                        ) {
                                                                            return (
                                                                                <TableCell
                                                                                    key={`row_column_${colIndex}`}
                                                                                    align={
                                                                                        value.align
                                                                                    }
                                                                                    size="small"
                                                                                    className={column.id === 'userName' ? classes.stickyColumn : ''}>
                                                                                    <Box
                                                                                        display="block"
                                                                                        //display="flex"
                                                                                        flexDirection="row"
                                                                                        alignItems={
                                                                                            value.align ==
                                                                                                'left'
                                                                                                ? 'flex-start'
                                                                                                : 'center'
                                                                                        }>
                                                                                        {value.showLabel ? (
                                                                                            <Typography
                                                                                                variant="h4"
                                                                                                flexGrow={
                                                                                                    1
                                                                                                }
                                                                                                fontSize={
                                                                                                    14
                                                                                                }
                                                                                                fontWeight={
                                                                                                    400
                                                                                                }>
                                                                                                {column.id ===
                                                                                                    'userName' ? (
                                                                                                    value.label.search(
                                                                                                        'DELETED'
                                                                                                    ) !==
                                                                                                        -1 ? (
                                                                                                        <>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    color: 'red',
                                                                                                                }}>{`DELETED`}</span>{' '}
                                                                                                            <span>
                                                                                                                {value.label.replace(
                                                                                                                    'DELETED',
                                                                                                                    ''
                                                                                                                )}
                                                                                                            </span>
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        value.label.replace(
                                                                                                            'DELETED',
                                                                                                            ''
                                                                                                        )
                                                                                                    )
                                                                                                ) : (
                                                                                                    value.label
                                                                                                )}
                                                                                            </Typography>
                                                                                        ) : null}

                                                                                        {value.showPermission &&
                                                                                            column.id !==
                                                                                            'completedOn' ? (
                                                                                            <UserMediaCircuit
                                                                                                value={
                                                                                                    value
                                                                                                }
                                                                                                header={
                                                                                                    false
                                                                                                }
                                                                                                column={
                                                                                                    column
                                                                                                }
                                                                                                colIndex={
                                                                                                    colIndex
                                                                                                }
                                                                                                row={
                                                                                                    row
                                                                                                }
                                                                                                rowIndex={
                                                                                                    rowIndex
                                                                                                }
                                                                                                setUserPermission={
                                                                                                    setUserPermission
                                                                                                }
                                                                                            />
                                                                                        ) : null}
                                                                                        {value.showChips
                                                                                            ? value.label
                                                                                                ? value.label
                                                                                                    .split(
                                                                                                        ', '
                                                                                                    )
                                                                                                    .map(
                                                                                                        (
                                                                                                            chipItem
                                                                                                        ) => {
                                                                                                            return (
                                                                                                                chipItem !==
                                                                                                                '' && (
                                                                                                                    <Chip
                                                                                                                        key={
                                                                                                                            chipItem
                                                                                                                        }
                                                                                                                        label={
                                                                                                                            chipItem
                                                                                                                        }
                                                                                                                        sx={{
                                                                                                                            mr: '4px',
                                                                                                                            mb: '2px',
                                                                                                                            '& .MuiChip-label':
                                                                                                                            {
                                                                                                                                maxWidth:
                                                                                                                                    '30ch',
                                                                                                                            },
                                                                                                                        }}
                                                                                                                    />
                                                                                                                )
                                                                                                            );
                                                                                                        }
                                                                                                    )
                                                                                                : null
                                                                                            : null}
                                                                                    </Box>
                                                                                </TableCell>
                                                                            );
                                                                        }
                                                                    } else {
                                                                        let showR =
                                                                            row[
                                                                                'showRow'
                                                                            ]
                                                                                .showRow;

                                                                        if (
                                                                            column.id !==
                                                                            'allModules' &&
                                                                            showR
                                                                        ) {
                                                                            return (
                                                                                <TableCell
                                                                                    key={`row_column_${colIndex}`}
                                                                                    align={
                                                                                        value.align
                                                                                    }
                                                                                    size="small"
                                                                                    className={column.id === 'userName' ? classes.stickyColumn : ''}>
                                                                                    <Box
                                                                                        display="block"
                                                                                        //display="flex"
                                                                                        flexDirection="row"
                                                                                        alignItems={
                                                                                            value.align ==
                                                                                                'left'
                                                                                                ? 'flex-start'
                                                                                                : 'center'
                                                                                        }>
                                                                                        {value.showLabel ? (
                                                                                            <Typography
                                                                                                variant="h4"
                                                                                                flexGrow={
                                                                                                    1
                                                                                                }
                                                                                                fontSize={
                                                                                                    14
                                                                                                }
                                                                                                fontWeight={
                                                                                                    400
                                                                                                }>
                                                                                                {column.id ===
                                                                                                    'userName' ? (
                                                                                                    value.label.search(
                                                                                                        'DELETED'
                                                                                                    ) !==
                                                                                                        -1 ? (
                                                                                                        <>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    color: 'red',
                                                                                                                }}>{`DELETED`}</span>{' '}
                                                                                                            <span>
                                                                                                                {value.label.replace(
                                                                                                                    'DELETED',
                                                                                                                    ''
                                                                                                                )}
                                                                                                            </span>
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        value.label.replace(
                                                                                                            'DELETED',
                                                                                                            ''
                                                                                                        )
                                                                                                    )
                                                                                                ) : (
                                                                                                    value.label
                                                                                                )}
                                                                                            </Typography>
                                                                                        ) : null}
                                                                                        {value.showPermission ? (
                                                                                            <UserMediaCircuit
                                                                                                value={
                                                                                                    value
                                                                                                }
                                                                                                header={
                                                                                                    false
                                                                                                }
                                                                                                column={
                                                                                                    column
                                                                                                }
                                                                                                colIndex={
                                                                                                    colIndex
                                                                                                }
                                                                                                row={
                                                                                                    row
                                                                                                }
                                                                                                rowIndex={
                                                                                                    rowIndex
                                                                                                }
                                                                                                setUserPermission={
                                                                                                    setUserPermission
                                                                                                }
                                                                                            />
                                                                                        ) : null}
                                                                                        {value.showChips
                                                                                            ? value.label
                                                                                                ? value.label
                                                                                                    .split(
                                                                                                        ', '
                                                                                                    )
                                                                                                    .map(
                                                                                                        (
                                                                                                            chipItem
                                                                                                        ) => {
                                                                                                            return (
                                                                                                                chipItem !==
                                                                                                                '' && (
                                                                                                                    <Chip
                                                                                                                        key={
                                                                                                                            chipItem
                                                                                                                        }
                                                                                                                        label={
                                                                                                                            chipItem
                                                                                                                        }
                                                                                                                        sx={{
                                                                                                                            mr: '4px',
                                                                                                                            mb: '2px',
                                                                                                                            '& .MuiChip-label':
                                                                                                                            {
                                                                                                                                maxWidth:
                                                                                                                                    '30ch',
                                                                                                                            },
                                                                                                                        }}
                                                                                                                    />
                                                                                                                )
                                                                                                            );
                                                                                                        }
                                                                                                    )
                                                                                                : null
                                                                                            : null}
                                                                                    </Box>
                                                                                </TableCell>
                                                                            );
                                                                        }
                                                                    }
                                                                }
                                                            )}
                                                    </StyledTableRow>
                                                );
                                            })
                                        : null}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <>

                            {
                                <ConfirmationDialog
                                    open={confirmDialog.get().open}
                                    messageFormat={messageFormat}
                                    OkButtonText={confirmDialog.get().OkButtonText}
                                    handleCnfClick={() =>
                                        handleSubmit(confirmDialog)
                                    }
                                    showFormattedMsg
                                    onCancelClick={() => {
                                        onConfirmationCancel();

                                    }}></ConfirmationDialog>
                            }
                        </>
                    </Box>

                </>
            ) : null}
        </>
        // </Paper>
    );
};
export default UserMediaCircuitList;
